import { isAfter } from 'date-fns';
import { REPRICE_TIMEOUT_MS } from '#/unified-rfqs/entities/drfq/domain';
import RfqsStore from '#/unified-rfqs/store/rfqs';

export default class DrfqStatusUpdater {
  private intervalId: null | ReturnType<typeof setTimeout> = null;
  constructor(private rfqStore: RfqsStore) {
    this.setup();
  }

  setup() {
    this.intervalId = setInterval(() => {
      this.rfqStore.selectAll().forEach((rfq) => {
        if (rfq.type !== 'drfq' || rfq.state !== 'RECENTLY_CLOSED') return;

        const repriceExpiresAt =
          rfq.last_updated_at.getTime() + REPRICE_TIMEOUT_MS;

        if (isAfter(Date.now(), repriceExpiresAt)) {
          this.rfqStore.updateOne(rfq.id, { state: 'CLOSED' });
        }
      });
    }, 1000);
  }

  teardown() {
    if (this.intervalId != null) clearInterval(this.intervalId);
  }
}
